import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzTableModule } from 'ng-zorro-antd/table';
import { P1Profile } from '../../../../core/api/mhsIdentityApiClient';
import { NfzService } from '../../services/nfz-service';

@Component({
  selector: 'app-p1-view',
  imports: [CommonModule, NzTableModule, NzFlexModule],
  templateUrl: './p1-view.html',
  styleUrl: './p1-view.scss',
})
export class P1ViewComponent {
  readonly nfzService = inject(NfzService);
  readonly loading = signal(true);
  readonly profiles = signal<P1Profile[]>([]);

  constructor() {
    this.loadProfiles();
  }

  private loadProfiles(): void {
    this.loading.set(true);
    this.nfzService.searchP1Access().subscribe({
      next: (result) => {
        this.profiles.set(result ?? []);
        this.loading.set(false);
      },
      error: (error) => {
        console.error('Unable to load P1 profiles.', error);
        this.loading.set(false);
      },
    });
  }
}
